export class FadeInOnEnterViewport {
  private observer: IntersectionObserver;

  // Konstanty pro CSS třídy
  private static readonly CLASSES = {
    BASE: 'fade-in',
    VISIBLE: 'fade-in--is-visible',
    TOP: 'fade-in--top',
    BOTTOM: 'fade-in--bottom',
  } as const;

  constructor(elements: NodeListOf<HTMLDivElement>) {
    // Vytvoření Intersection Observer pro sledování viditelnosti elementů
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Přidání třídy pro viditelnost
            entry.target.classList.add(FadeInOnEnterViewport.CLASSES.VISIBLE);
            // Ukončení sledování elementu
            this.observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px',
      }
    );

    // Inicializace elementů
    elements.forEach((element) => {
      const rect = element.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const isInitiallyVisible = rect.top >= 0 && rect.bottom <= viewportHeight;

      // Přidání základní třídy pro animaci
      element.classList.add(FadeInOnEnterViewport.CLASSES.BASE);

      // Přidání směrové třídy podle pozice vůči středu viewportu
      if (rect.top < viewportHeight / 2) {
        element.classList.add(FadeInOnEnterViewport.CLASSES.TOP);
      } else {
        element.classList.add(FadeInOnEnterViewport.CLASSES.BOTTOM);
      }

      // Pokud je element již plně viditelný, přidej třídu pro viditelnost okamžitě
      if (isInitiallyVisible) {
        element.classList.add(FadeInOnEnterViewport.CLASSES.VISIBLE);
      } else {
        this.observer.observe(element);
      }
    });
  }

  // Metoda pro odpojení observeru
  disconnect() {
    this.observer.disconnect();
  }
}
